import React from 'react';

interface InfoBoxProps {
  type: 'info' | 'warning' | 'success' | 'error';
  children: React.ReactNode;
}

const InfoBox: React.FC<InfoBoxProps> = ({ type, children }) => {
  return (
    <div className={`info-box ${type}`}>
      {children}
    </div>
  );
};

export default InfoBox; 